import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { createApplication } from "./applications";
import defaultValuesOld from "../scenarios/edu-scenarios";
import { isAppAccessUserFn } from "../../utils/users";
import { getAllAccounts } from "../helpers/get-accounts";

const apps1 = defaultValuesOld().applications1;
const apps2 = defaultValuesOld().applications2;
const apps3 = defaultValuesOld().applications3;
const apps4 = defaultValuesOld().applications4;
const apps5 = defaultValuesOld().applications5;

const acc1 = defaultValuesOld().accounts1;
const acc2 = defaultValuesOld().accounts2;
const acc3 = defaultValuesOld().accounts3;
const acc4 = defaultValuesOld().accounts4;
const acc5 = defaultValuesOld().accounts5;

const addData = async (data, orgId, dept) => {
  let name = "";
  let description = "";
  let ID = "";
  let Users = 0;
  let Services = null;
  let Metadata = null;

  if (dept) {
    name = dept.Name;
    description = dept.Description;
    ID = dept.ID;
    Users = dept.Users;
  }
  let _orgId = uuidv4();
  if (orgId) {
    _orgId = orgId;
  }
  if (data) {
    name = data.Name;
    description = data.Description;
    Users = data.Users;
  }
  const applications = [];
  var deptApps = [];
  var deptAccs = [];
  if (ID === "98ea91b7-551f-4d35-a113-b37fcd840a71") {
    deptApps = apps1;
    deptAccs = acc1;
  }
  if (ID === "72ka91b7-551f-4d35-a113-b37fcd840a71") {
    deptApps = apps2;
    deptAccs = acc2;
  }
  if (ID === "31rba91b7-551f-4d35-a113-b37fcd840a71") {
    deptApps = apps3;
    deptAccs = acc3;
  }
  if (ID === "830e65e6-c6ca-42b3-8b9d-2260cf3ac09e") {
    deptApps = apps4;
    deptAccs = acc4;
  }
  if (ID === "6fd25c90-b7d2-49c1-ace9-945cb173e3d6") {
    deptApps = apps5;
    deptAccs = acc5;
  }

  for (const _app of deptApps) {
    let app = await createApplication(null, null, null, _app);
    applications.push(app);
  }

  return {
    Name: name || "Default Dept",
    OrganizationId: _orgId,
    Description: description,
    ID: ID,
    CreatedOn: faker.date.past(),
    ModifiedOn: faker.date.past(),
    ParentOrganizationId: "",
    ModifiedBy: null,
    CreatedBy: 2,
    CustomerId: uuidv4(),
    Applications: applications,
    Accounts: deptAccs,
    Preferences: null,
    DepartmentCode: dept && dept.DepartmentCode,
    Services: Services,
    Type: "PROJECT",
    Users: Users,
    Metadata: Metadata,
  };
};

export const createDepartment = async (data, orgId, dept) => {
  const deptData = await addData(data, orgId, dept);
  return deptData;
};

export const getDepartmentsList = () => {
  let isAppAccessUser = isAppAccessUserFn();
  if (isAppAccessUser) {
    return [defaultValuesOld().departments[2]];
  }
  return defaultValuesOld().departments;
};

export const addProjectData = async (data, orgId) => {
  const accountsList = await getAllAccounts();

  let foundAccounts = accountsList.filter((account) =>
    data.Accounts.includes(account.AccountNumber)
  );
  return {
    Description: data.Description,
    ID: uuidv4(),
    Name: data.Name,
    OrganizationId: orgId,
    CreatedBy: 8,
    CreatedOn: faker.date.future(),
    Applications: 0,
    Accounts: foundAccounts,
    Services: data.Services,
    Metadata: data.Metadata,
  };
};

export const createProject = async (data, orgId) => {
  const projectData = await addProjectData(data, orgId);
  return projectData;
};
